export enum MoveState {
  Run = "run",
  Walk = "walk",
}
